export const DIALOG_FONT_FAMILY = "Roboto, Helvetica, Arial, sans-serif";

export const DIALOG_COLORS = {
	text: "#1f2937",
	muted: "#6b7280",
	border: "#d9dde3",
	surface: "#f1f3f6",
	noteBackground: "#e8f0fb",
	noteText: "#0b2a5b",
	link: "#1a56b0",
	doHeading: "#2e7d32",
	dontHeading: "#c62828",
	required: "#c62828",
};

// Applied on the Dialog so everything inside, MUI defaults included, uses the same font
export const dialogPaperSx = {
	"& .MuiDialog-paper": {
		fontFamily: DIALOG_FONT_FAMILY,
		color: DIALOG_COLORS.text,
		borderRadius: "12px",
	},
};

export const dialogHeaderSx = {
	fontFamily: DIALOG_FONT_FAMILY,
	px: 3.5,
	pt: 3,
	pb: 2,
	pr: 8,
	borderBottom: `1px solid ${DIALOG_COLORS.border}`,
};

export const dialogFooterSx = {
	px: 3.5,
	py: 2,
	borderTop: `1px solid ${DIALOG_COLORS.border}`,
	gap: 1.5,
};

export const footerButtonSx = {
	fontFamily: DIALOG_FONT_FAMILY,
	fontSize: 14,
	fontWeight: 500,
	letterSpacing: "0.04em",
	textTransform: "uppercase" as const,
	px: 2.5,
	py: 1.25,
	borderRadius: "6px",
};
